import { Modal, Image } from 'antd';
import { useRef, useState, useEffect } from 'react';
import Media from '../../assets/imgage/wordBook/Media.png';

const ModalCustom = ({
    isOpen = false,
    onOk,
    onClose,
    title = '',
    confirmText = "",
    cancelTxt = ""
}) => {

    useEffect(() => {
    }, []);

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            footer={null}
            closable={false}
            width={350}
            className="custom-wordbook-modal"
        >
            <div className="bInner">
                <div className="bDetails">
                    <h2>{title}</h2>
                    
                    <button className='confirmBtn' onClick={onOk}>{confirmText}</button>
                    <button className='cancelBtn' onClick={onClose}>{cancelTxt}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalCustom;
